/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/31
 */
import React,{Component} from 'react';
import {Link} from 'react-router-dom';
import extendSearch from '../../../utils/extendSearch';

class Links extends Component {
  constructor (props) {
    super(props);
    this.className = "store-pagination-link";
  }
  getLink (children, location, extendQuery) {
    const { search, query } = extendSearch(location.search, extendQuery);
    return <Link to={{
      search,
      pathname: location.pathname,
      state: query
    }} className={this.className}>
      {children}
    </Link>
  }
  getA (children) {
    return <a href="javascript:void(0);" className={this.className}>
      {children}
    </a>
  }
  render (){
    const { children, location, query } = this.props;
    return location
      ? this.getLink(children, location, query)
      : this.getA(children);
  }
}

export default Links;



// WEBPACK FOOTER //
// ./src/components/lib/pagination/link.js